<div class="rounded-md border border-slate-700 bg-slate-800/40 p-2">
  @if (view().title) {
    <div class="mb-1 text-xs font-semibold text-slate-200">{{ view().title }}</div>
  }
  @if (view().rows.length === 0) {
    <div class="text-xs text-slate-400">No facts provided.</div>
  } @else {
    <dl class="space-y-0.5 text-xs">
      @for (f of view().rows; track $index) {
        <div class="flex items-baseline justify-between gap-3">
          <dt class="text-slate-400">{{ f.label }}</dt>
          <dd class="text-right font-mono text-slate-100">{{ f.value }}</dd>
        </div>
      }
    </dl>
  }
</div>
